import { Config } from "./base";

const config: Config = {
  environment: "production",
  api: {
    endpoint: "https://api.atlas.minimum.eco",
    disableCache: false,
  },
  sentry: {
    dsn: "https://ef3170aac9d6428c9f20a0295d0dff43@o346449.ingest.sentry.io/4503970106507264",
    project: "atlas-dashboard-production",
  },
  auth0: {
    clientId: "Jv15yQF4f4Pv4aF9wkLIrs7EiGU5zKmh",
    domain: "auth.minimum.com",
    redirectUrl: "https://dashboard.minimum.eco/auth/callback",
  },
  app: {
    sem_ver: process.env.APP_VERSION,
    name: process.env.APP_NAME,
  },
  segment: {
    writeKey: "aSPkB4Sb7oIQw9NG2cGQRzKgtZIR09FG",
    cdn: "https://analytics-a.minimum.eco",
  },
  formbricks: {
    environmentId: "clzww7ji90009d5knsl79eqcx",
    apiHost: "https://formbricks.novisto.net",
  },
  supportEmail: "support@minimum.com",
  features: {
    TESTING_FEATURES: false,
  },
};

export type { Config };
export default config;
